window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// GSAP
// import {
//     gsap,
//     ScrollTrigger
// } from "gsap/all";
// import {
//     DrawSVGPlugin
// } from "gsap/DrawSVGPlugin";
// gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

// import Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle';
// import '@fortawesome/fontawesome-free/js/all.js';

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fNavbarMenu = require('./components/navbar-menu')
const fForm = require('./components/form')
const fReadingProgrees = require('./components/reading-progress')
const fCarousels = require('./components/carousels')
const fScrollTop = require('./components/scroll-top')
const fWoocommerce = require('./components/woocommerce')

// const fCarouselsFlex = require('./components/carousels-flex')
// const fMainMenu = require('./components/main-menu')
// Vue Support Function
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

const InitVueComponents = () => {
    Vue.component(
        'faq',
        require('./vue/faq').default
    )
    Vue.component(
        'map-point',
        require('./vue/map-point').default
    )
    Vue.component(
        'blog-posts',
        require('./vue/blog-posts').default
    )
    Vue.component(
        'services-posts',
        require('./vue/services-posts').default
    )
    Vue.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyB0A7LRJUsgvRzTBpH-IraLd6V9m9lyNwY',
            libraries: 'places',
        },
    })
    
    // Init Vue Instance
    new Vue({
        el: document.getElementById('vue-space'),
    })
}

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    const menuAccordions = document.querySelectorAll(".menu-accordion");
    
    menuAccordions.forEach(accordion => {
        const content = accordion.querySelector(".menu-accordion-content");
        
        const close = () => {
            content.style.maxHeight = null;
            accordion.dataset.open = "false";
            setTimeout(() => {
                document.removeEventListener("click", closeOutside);
            })
        }
        
        const closeOutside = (e) => {
            if ( !content.contains(e.target) ) {
                close();
            }
        }
        
        accordion.addEventListener("click", () => {
            content.style.maxHeight = `${content.scrollHeight}px`;
            accordion.dataset.open = "true";
            
            setTimeout(() => {
                document.addEventListener("click", closeOutside);
            })
        })
    })
    fSmoothScroll()
    fNavbarMenu();
    fForm()
    fReadingProgrees()
    fScrollTop()
    fWoocommerce()
    if ( document.getElementById('vue-space') ) InitVueComponents()
    // fCarouselsFlex.init();
    // fMainMenu.init();
    
    // swiper lazy load
    if ( document.querySelector(".swiper") ) {
        let isLoadSwiper = false;
        document.querySelectorAll(".swiper").forEach(item => {
            const swiperObserve = new IntersectionObserver(entries => {
                for (const entry of entries) {
                    if ( entry.isIntersecting ) {
                        swiperObserve.unobserve(item);

                        if ( !isLoadSwiper ) {
                            fCarousels.init();
                        }

                        isLoadSwiper = true;
                    }
                }
            })

            swiperObserve.observe(item);
        })
    }
})